import type { IndexPlatformStocksInput, PaginatedPlatformStocks, PlatformStockLog } from '@gozoki/api-types'
import { gozokiApiWithAuth } from '../gozokiApi'

export type FetchPlatformStocksParams = IndexPlatformStocksInput

export const fetchPlatformStocks = async (params?: FetchPlatformStocksParams) => {
  const response = await gozokiApiWithAuth.get<PaginatedPlatformStocks>('/platform-stocks', {
    params,
  })
  return response.data
}

export const fetchPlatformStockLogs = async (id: number, limit?: number) => {
  const response = await gozokiApiWithAuth.get<PlatformStockLog[]>(`/platform-stocks/${id}/logs`, {
    params: limit ? { limit } : undefined,
  })
  return response.data
}
